import { m } from 'framer-motion';
import { useEffect, useState, useMemo } from 'react';
import { styled } from '@mui/material/styles';
import { Container } from '@mui/system';
import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import SimilarCarousel from './CultureObjects/SimilarCarousel';
// import { webalize } from 'webalize';
//  import { varFade } from '../../animate';
import MotionContainer from '../animate/MotionContainer';
import ItemCard from '../custom/Cards/ItemCard';
import COLabel from '../custom/Labels/COLabel';
import useLocales from '../../hooks/useLocales';
import useWindowSize from '../../hooks/useWindowSize';
import useResponsive from '../../hooks/useResponsive';

import ShowMore from '../custom/Labels/ShowMore';
import { dispatch, useSelector } from '../../redux/store';
import { getCOListSearch } from '../../redux/slices/culturalObject';
import { addToFavourites } from '../../redux/slices/favourites';

FolderCollection.propTypes = {
  title: PropTypes.string,
  folder: PropTypes.any,
  redirect: PropTypes.string,
  parent: PropTypes.any,
};

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(6, 0),
  backgroundColor: theme.palette.background.paper,
}));

// ----------------------------------------------------------------------

export default function FolderCollection({ title, folder, redirect, parent }) {
  const navigation = useNavigate();
  const { translate, currentLang } = useLocales();
  const [loopForTiles, setLoopForTiles] = useState([0, 1, 2]);
  const { favourites } = useSelector((state) => state.favourites);
  const windowSize = useWindowSize();
  const { culturalObject } = useSelector((state) => state.culturalObject);
  const { results } = culturalObject;
  const [count, setCount] = useState(12);
  const isMobile = useResponsive('down', 'sm');
  useEffect(() => {
    const abortCtrl = new AbortController();
    if (folder.type === 1) {
      dispatch(
        getCOListSearch({
          size: 12,
          page: 1,
          ...folder.culturalObjectSearchDefinition,
          signal: abortCtrl.signal,
          locale: currentLang.getValue,
        })
      );
    }
    return () => abortCtrl.abort();
  }, [folder, currentLang.getValue]);

  useEffect(() => {
    if (windowSize === 'xs' && loopForTiles.length !== 1) {
      setLoopForTiles([0]);
    } else if (windowSize === 'sm' && loopForTiles.length !== 2) {
      setLoopForTiles([0, 1]);
    } else if (windowSize === 'lg' && loopForTiles.length !== 3) {
      setLoopForTiles([0, 1, 2]);
    }
  }, [windowSize, loopForTiles]);

  // const redirectFun = () => {
  //   navigation(`${redirect}?search=${webalize(search)}`);
  // };

  const pathCatalogue = window.location.pathname.includes('en/') ? `/en${translate('urls.co')}` : translate('urls.co');

  const redirectFun = () => {
    const tempFilter = { ...folder.culturalObjectSearchDefinition };
    const params = new URLSearchParams();
    if (tempFilter.originDateFrom) {
      tempFilter.originDateFrom = `${new Date(tempFilter.originDateFrom).getFullYear()}`;
    }
    if (tempFilter.originDateTo) {
      tempFilter.originDateTo = `${new Date(tempFilter.originDateTo).getFullYear()}`;
    }
    tempFilter.sort = tempFilter.sortAttribute;
    params.set('filter', JSON.stringify(tempFilter));
    params.set('page', 1);
    params.set('search', tempFilter.searchText);
    navigation(`${pathCatalogue}?${params}`);
  };

  const heart = (newItem) => {
    dispatch(addToFavourites({ ...newItem, type: 'object' }));
  };

  const loadMore = () => {
    setCount(count + 12);
  };

  const itemsShow = useMemo(
    () =>
      loopForTiles.map((number) => (
        <Grid key={number} xs={12} sm={6} md={4} item>
          {folder.type === 0 &&
            folder.culturalObjects.map((item, idx) => (
              <div key={idx}>
                {idx % loopForTiles.length === number && idx < count && (
                  <ItemCard
                    img={
                      // eslint-disable-next-line no-nested-ternary
                      item.thumbnail.includes('http')
                        ? item.thumbnail
                        : item.thumbnail !== undefined && item.thumbnail !== ''
                        ? `${process.env.REACT_APP_API_URL}/image/download/${item.thumbnail}?sizeIndex=0`
                        : ''
                    }
                    favorite={favourites.findIndex((s) => s.key === item.key) !== -1}
                    width={12}
                    fixedWidth
                    heartAction={() => heart(item)}
                    action={`${redirect}/${item.culturalObjectKey || item.key}`}
                  >
                    <COLabel
                      title={item.name}
                      author={item.prefferedAuthor[0]}
                      age={item.displayOriginDate}
                      category={item.categories[0]?.name || ''}
                    />
                  </ItemCard>
                )}
              </div>
            ))}
        </Grid>
      )),
    [loopForTiles, folder, count, favourites, redirect]
  );

  const itemsShowCollection = useMemo(
    () =>
      loopForTiles.map((number) => (
        <Grid key={number} xs={12} sm={6} md={4} item>
          {folder.type === 1 &&
            results.map((item, idx) => (
              <div key={idx}>
                {idx % loopForTiles.length === number && (
                  <ItemCard
                    img={
                      // eslint-disable-next-line no-nested-ternary
                      item.thumbnail.includes('http')
                        ? item.thumbnail
                        : item.thumbnail !== undefined && item.thumbnail !== ''
                        ? `${process.env.REACT_APP_API_URL}/image/download/${item.thumbnail}?sizeIndex=0`
                        : ''
                    }
                    favorite={favourites.findIndex((s) => s.key === item.key) !== -1}
                    width={12}
                    fixedWidth
                    heartAction={() => heart(item)}
                    action={`${redirect}/${item.culturalObjectKey || item.key}`}
                  >
                    <COLabel
                      title={item.name}
                      author={item.prefferedAuthor[0]}
                      age={item.displayOriginDate}
                      category={item.categories[0]?.name || ''}
                    />
                  </ItemCard>
                )}
              </div>
            ))}
        </Grid>
      )),
    [favourites, folder, loopForTiles, redirect, results]
  );
  return (
    <>
      {isMobile && folder && parent?.folders?.[0] !== undefined && parent?.folders?.[0]?.folderKey === folder?.key && (
        <RootStyle className="hidden-print">
          <Container component={MotionContainer} sx={{ position: 'relative', height: '100%' }}>
            <m.div /* variants={varFade().inUp} */>
              <Typography variant="h4" style={{ marginBottom: '24px' }}>
                {translate(title)}
              </Typography>
              <SimilarCarousel
                items={folder.type === 0 ? folder.culturalObjects : results}
                redirect={redirect}
                onClick={redirectFun}
                noMore={folder.type === 0}
              />
            </m.div>
          </Container>
        </RootStyle>
      )}
      {!isMobile && folder && parent?.folders?.[0] !== undefined && parent?.folders?.[0]?.folderKey === folder?.key && (
        <RootStyle className="hidden-print">
          <Container component={MotionContainer} sx={{ position: 'relative', height: '100%' }}>
            <m.div /* variants={varFade().inUp} */>
              <Typography variant="h4">{translate(title)}</Typography>
              <Grid container spacing={'24px'} style={{ marginTop: '12px' }}>
                {folder && folder.type === 0 && itemsShow}
                {folder && folder.type === 1 && itemsShowCollection}
              </Grid>
            </m.div>
            {folder.type === 0 && count <= folder.culturalObjects.length && (
              <ShowMore text="default.showMore" onClick={loadMore} />
            )}
            {folder.type === 1 && <ShowMore text="objects.showMore" onClick={redirectFun} />}
          </Container>
        </RootStyle>
      )}
    </>
  );
}
